import { Content } from "../components/Content";

export default function HomePage() {
  return <Content title="All Apps" />;
}
